import React, { Suspense, useEffect, useState } from 'react';
import Header from '../Header/header';
import { CommonUtilities } from '../../commonUtils';
import korrectLogo from '../../assets/images/korrectLogoIcon.png';



export default function ButtonsLabelsInputs(autoOpen: any) {

    return (
        <div className='ws-12'>



            <style>{` 

                .box{ border-radius : 4px !important ;} 
                [class*="btn"], .nav.nav-tabs li, input{ border-radius : 4px !important ;} 
                li{ border-radius : 4px !important ;} 
                .topFrame{ border-radius: 6px; } 
                
            `}</style>


            <div className="plxl prxl">
                <div className="ptxl mtl ptl">
                    <div className="ws-9">
                        <span className="ws-12 text-bold text-xl">Buttons / Labels / Inputs</span>
                        <span className="ws-12 ptl text-bold text-m turquoise">Basic Button Layout</span>
                    </div>
                </div>
                <div className="ws-12 ptxl">
                    <div className="ws-12">

                        <a className="icon-btn edit">
                            Save
                        </a>

                        <a className="icon-btn primary" >
                            Performance
                        </a>

                        <a className="icon-btn delete">
                            Close
                        </a>

                        <a className="icon-btn info">
                            Save
                        </a>

                        <a className="btn-warning">
                            Calculation
                        </a>

                        <a className="btn-grey">
                            Disabled
                        </a>



                        <button className="icon-btn info icon-btn edit"><i className="icon-download1"></i> Export Listing</button>






                    </div>
                </div>
            </div>

            <div className="ws-12 plxl prxl">
                <div className="ptxl mtl ptl">
                    <div className="ws-9 mtl">
                        <span className="ws-12 ptl text-bold text-m turquoise">Tags</span>
                    </div>
                </div>
                <div className="ws-12">
                    <div className="ws-12">

                        <div className="tagging-container mtl">
                            <div className="tagging">
                                <span className="mrs">
                                    Tag 1
                                    <i className="icon-cancel2 pls pull-right"></i>
                                </span>

                                <span className="mrs">
                                    Tag 2
                                    <i className="icon-cancel2 pls pull-right"></i>
                                </span>

                                <span className="mrs">
                                    Tag 3
                                    <i className="icon-cancel2 pls pull-right"></i>
                                </span>
                            </div>
                        </div>


                    </div>
                </div>
            </div>

            <div className='ws-12 plxl prxl'>
                <div className="ptxl mtl ptl">
                    <div className="ws-9 mtl">
                        <span className="ws-12 ptl text-bold text-m turquoise">Notifications</span>
                    </div>
                </div>
                <div className="alert alert-warning mb mtl">
                    Calculations Initiated
                </div>

            </div>

            <div className="ws-12 plxl prxl">
                <div className="ptxl mtl ptl">
                    <div className="ws-9 mtl">
                        <span className="ws-12 ptl text-bold text-m turquoise">Icon Buttons</span>
                    </div>
                </div>
                    <div className="ws-12">

                        <div className="tagging-container mtl">
                            <div className="tagging p0">

                                <div className="icon-btn primary pull-left btn-xs">
                                    <i className="icon-pen"></i>
                                </div>
                                
                                <div className="icon-btn delete pull-left btn-xs">
                                    <i className="icon-trash"></i>
                                </div>

                                <a className="icon-btn edit pull-right btn-sm">
                                    <i className="icon-sigma-sum"></i>
                                </a>

                                <a className="icon-btn edit pull-right btn-sm">
                                    <i className="icon-alpha"></i>
                                </a>

                                <a className="icon-btn edit btn-sm pull-right">
                                    <i className="icon-Transaction"></i>
                                </a>

                                <button className="btn-queue btn-sm pull-right">
                                    <i className="icon-database1"></i>
                                </button>

                            </div>
                        </div>


                    </div>
            </div>


            <div className='ws-12 plxl prxl'>
                <div className="ptxl mtl ptl">
                    <div className="ws-9 mtl">
                        <span className="ws-12 ptl text-bold text-m turquoise">Hover Sub Menu</span>
                    </div>
                </div>
                
                <div className='ws-12'>
                    <div className="verticalMediumWide hover-box text-center mtl">

                        <ul className="hover-block textboxDropdownList box overflowVisible contentWidth">

                            <li className="hover-box width-auto">
                                <button type="button" className="icon-btn edit btn-sm">
                                    <i className="icon-edit1"></i>
                                </button>
                            </li>

                            <li className="hover-box  width-auto">
                                <button className="icon-btn delete btn-sm">
                                    <i className="icon-file-pdf-o"></i>
                                </button>
                            </li>

                            <li className="hover-box  width-auto">
                                <button className="icon-btn delete btn-sm">
                                    <i className="icon-file-pdf-o"></i>
                                </button>
                            </li>

                            <li className="hover-box  width-auto">
                                <button className="icon-btn edit btn-sm">
                                    <i className="icon-file-excel-o"></i>
                                </button>
                            </li>

                            <li className="hover-box  width-auto">
                                <a className="icon-btn edit btn-sm">
                                    <i className="icon-Transaction"></i>
                                </a>
                            </li>

                        </ul>

                        <button type="button" className=" btn-sm icon-btn edit">
                            <i className="icon-stack2"></i>
                        </button>
                    </div>

                </div>



            </div>




            <div className="ws-12 plxl prxl">
                <div className="ptxl mtl ptl">
                    <div className="ws-9 mtl">
                        <span className="ws-12 ptl text-bold text-m turquoise">Types</span>
                    </div>
                </div>
                <div className="ws-12">
                    <div className="ws-12">

                        <div className="tagging-container mtl">
                            <div className="tagging p0">
                               
                                <a className="btn-xs ms text-center" style={{ background: '#980A0B' , color: '#ffffff' } }>
                                    Data Analytics
                                </a>

                                <a className="btn-xs ms text-center" style={{ background: '#029BE5' , color: '#ffffff' } }>
                                    Queue Grouping
                                </a>

                                <a className="btn-xs ms text-center" style={{ background: '#7B1FA2' , color: '#ffffff' } }>
                                    Royalty Terms
                                </a>

                            </div>
                        </div>


                    </div>
                </div>
            </div>





            <div className="ws-12 plxl prxl">
                <div className="ptxl mtl ptl">
                    <div className="ws-9 mtl">
                        <span className="ws-12 ptl text-bold text-m turquoise">Tags</span>
                    </div>
                </div>
                <div className="ws-12">
                    <div className="ws-12">

                        <a className="btn-xs text-center ws-8 displayFlex mt" style={{ background: '#1A5E20' , color: '#FFFFFF' }} >
                            <i className="icon-circle-left p0 m0 ws-3 mtss white"></i>

                            <span className="inline ws-12 ps ml mr white text-bold">Approved</span>

                            <i className="icon-circle-right p0 m0 ws-3 mtss white"></i>
                        </a>


                    </div>
                </div>
            </div>





            <div className="ws-12 plxl prxl">
                <div className="ptxl mtl ptl">
                    <div className="ws-9 mtl">
                        <span className="ws-12 ptl text-bold text-m turquoise">Tags</span>
                    </div>
                </div>
                <div className="ws-12">
                    <div className="ws-12">

                        <div className="tagging-container mtl">
                            <div className="tagging">
                               
                                <span className="mrs">
                                    Tag 3
                                    <i className="icon-cancel2 pls pull-right"></i>
                                </span>
                            </div>
                        </div>


                    </div>
                </div>
            </div>










        </div>
    )
}